import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "roleSelect", "employeeFields" ]

  connect() {
    this.toggleEmployeeFields()
  }

  toggleEmployeeFields() {
    if (this.roleSelectTarget.value !== "client") {
      this.employeeFieldsTarget.classList.remove("hidden")
      this.employeeFieldsTarget.querySelectorAll("input").forEach(input => {
        input.removeAttribute("disabled")
      })
    } else {
      this.employeeFieldsTarget.classList.add("hidden")
      this.employeeFieldsTarget.querySelectorAll("input").forEach(input => {
        input.setAttribute("disabled", "true")
      })
    }
  }
}
